import { InputField } from "@/components/common/InputField";

interface SelectInputFieldProps {
	label: string;
	error?: string;
	value?: string;
	onChange?: (value: string) => void;
	disabled?: boolean;
	testId?: string;
	/** 閉じた状態に出す中身。指定しなければ選択中 option のテキストを出す。 */
	selectedDisplay?: React.ReactNode;
	children: React.ReactNode;
}

/**
 * ラベル付きのセレクトボックス。`appearance: base-select` 対応ブラウザでは
 * ドロップダウン (`::picker`) やオプションをアプリのデザインに合わせて描画し、
 * 非対応ブラウザ (Safari など) ではネイティブの装飾セレクトにフォールバックする。
 * 装飾した option は `selectedDisplay` で閉じた状態にも同じ見た目を出す。Chrome の
 * `<selectedcontent>` は option の中身が後から変わっても複製し直さないため使わない。
 * スタイルは globals.css の `.ds-select` で定義する。
 */
export function SelectInputField({
	label,
	error,
	value,
	onChange,
	disabled = false,
	testId,
	selectedDisplay,
	children,
}: SelectInputFieldProps) {
	return (
		<InputField label={label} error={error}>
			<select
				className="ds-select"
				value={value}
				onChange={onChange ? (e) => onChange(e.target.value) : undefined}
				disabled={disabled}
				data-testid={testId}
			>
				{selectedDisplay !== undefined && <button>{selectedDisplay}</button>}
				{children}
			</select>
		</InputField>
	);
}
